/* BOTEA — bannière plein écran : en-tête transparent, fondu entre images */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var timers = [];

  function measureHeader() {
    var header = document.querySelector('.header-wrapper');
    if (header) root.style.setProperty('--bt-header-h', header.offsetHeight + 'px');
  }
  function onScroll() {
    root.classList.toggle('bt-header-solid', window.scrollY > 40);
  }

  function initSlides(hero) {
    var slides = hero.querySelectorAll('[data-bt-slide]');
    var dotsWrap = hero.querySelector('[data-bt-hero-dots]');
    if (slides.length < 2) return;
    var i = 0;
    var interval = (parseInt(hero.getAttribute('data-bt-interval'), 10) || 6) * 1000;
    var dots = [];
    function show(n) {
      i = n;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === n); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === n); });
    }
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (_, k) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Image ' + (k + 1));
        b.addEventListener('click', function () { show(k); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }
    show(0);
    if (!reduceMotion) {
      timers.push(setInterval(function () { show((i + 1) % slides.length); }, interval));
    }
  }

  function init() {
    var hero = document.querySelector('[data-bt-overlay-hero]');
    timers.forEach(clearInterval);
    timers = [];
    if (!hero) { root.classList.remove('bt-overlay-header', 'bt-header-solid'); return; }
    root.classList.add('bt-overlay-header');
    measureHeader();
    onScroll();
    initSlides(hero);
    var video = hero.querySelector('video');
    if (video && reduceMotion) video.pause();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', measureHeader);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
})();